<template>
  <div class="layout-topbar">
    <div class="topbar-left">
      <ul class="topbar-menu">
        <li class="search-item">
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              type="text"
              v-model="value"
              placeholder="Search"
              class="topbar-search"
            />
          </span>
        </li>
      </ul>
    </div>
    <div class="topbar-right">
      <ul class="topbar-menu">
        <li>
          <div class="icon"><i class="pi pi-shopping-cart"></i></div>
        </li>
        <li>
          <div class="icon">
            <RouterLink to="/products">
              <i class="pi pi-home"></i>
            </RouterLink>
          </div>
        </li>
        <li>
          <div class="icon"><i class="pi pi-user"></i></div>
        </li>
        <li>
          <span class="user">
            <router-link to="/profile"
              >{{ $store.getters["profile/name_backup"] }}
              {{ $store.getters["profile/surname_backup"] }}</router-link
            ></span
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppTopbar",
  emits: ["menu-button-click", "right-menubutton-click"],
  props: {
    topbarUserMenuActive: Boolean,
  },
  data() {
    return {
      items: [],
      value: "",
    };
  },
  computed: {},
  methods: {
    onMenuButtonClick(event) {
      this.$emit("menu-button-click", event);
    },
    onRightMenuClick(event) {
      this.$emit("right-menubutton-click", event);
    },
  },
};
</script>
